import { CheckCircle, MessageCircle, ArrowLeft, Clock, UserCheck, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { config } from "@/config";

export default function ThankYouPage() {
  return (
    <div
      data-testid="thank-you-page"
      className="min-h-screen bg-[#F9FAFB] flex items-center justify-center px-6"
    >
      <div className="max-w-xl w-full">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-emerald-50 flex items-center justify-center">
              <CheckCircle size={32} className="text-emerald-500" strokeWidth={1.5} />
            </div>
          </div>

          <p
            className="text-lg font-bold tracking-tight text-[#0F3D56] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {config.brand.shortName}
          </p>

          <h1
            data-testid="thank-you-title"
            className="text-3xl md:text-4xl font-bold tracking-tight text-[#111827] mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Hemos recibido tu solicitud
          </h1>

          <p
            data-testid="thank-you-message"
            className="text-base leading-relaxed text-gray-600 max-w-md mx-auto"
          >
            Tu información ha sido registrada correctamente. Un asesor de DSA
            revisará tu perfil y se pondrá en contacto contigo.
          </p>
        </div>

        {/* What happens next */}
        <div
          data-testid="thank-you-next-steps"
          className="bg-white p-8 border border-gray-100 shadow-sm mb-8"
        >
          <h2
            className="text-lg font-semibold text-[#111827] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            ¿Qué sigue?
          </h2>
          <div className="space-y-5">
            <div className="flex gap-4">
              <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center border border-[#0F3D56]/15 text-[#0F3D56]">
                <UserCheck size={16} strokeWidth={1.5} />
              </div>
              <div>
                <p className="text-sm font-bold text-[#111827]">Revisión de perfil</p>
                <p className="text-sm text-gray-500">
                  Un asesor analizará tu situación y objetivos para preparar una orientación adecuada.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center border border-[#0F3D56]/15 text-[#0F3D56]">
                <Phone size={16} strokeWidth={1.5} />
              </div>
              <div>
                <p className="text-sm font-bold text-[#111827]">Contacto por WhatsApp</p>
                <p className="text-sm text-gray-500">
                  Te escribiremos al WhatsApp que proporcionaste. Revisa tus mensajes.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center border border-[#0F3D56]/15 text-[#0F3D56]">
                <Clock size={16} strokeWidth={1.5} />
              </div>
              <div>
                <p className="text-sm font-bold text-[#111827]">Plazo estimado: 24 horas</p>
                <p className="text-sm text-gray-500">
                  Si no recibes respuesta en ese plazo, contáctanos directamente.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={config.whatsapp.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="thank-you-whatsapp-cta"
            className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-3.5 text-sm font-medium hover:bg-[#20BD5A] transition-colors"
          >
            <MessageCircle size={18} />
            Hablar por WhatsApp
          </a>
          <Link
            to="/"
            data-testid="thank-you-back-link"
            className="inline-flex items-center justify-center gap-2 border border-gray-300 text-gray-700 px-6 py-3.5 text-sm font-medium hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
        </div>

        {/* Note */}
        <p className="mt-8 text-xs text-gray-400 text-center">
          ¿Necesitas atención inmediata? Escríbenos directamente por WhatsApp.
        </p>
      </div>
    </div>
  );
}
